import { render, staticRenderFns } from "./InsuranceDetail.vue?vue&type=template&id=89bf958a&"
import script from "./InsuranceDetail.vue?vue&type=script&lang=js&"
export * from "./InsuranceDetail.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceDetail.vue?vue&type=style&index=0&id=89bf958a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports